import createCachedSelector from 're-reselect';

import { getDefaultRegionsSearchEditorState } from '../../service/RegionsHelpers/RegionsHelpers';
import { RegionsSearchEditorsState, RegionsSearchEditorState } from '../../typings/regionsSearchEditor';
import { State } from '../../typings/state';

export const selectRegionsSearchEditorValue = createCachedSelector(
    (state: State) => state.regionsSearchEditor,
    (state: State, editorId: string) => editorId,
    (editors: RegionsSearchEditorsState, editorId: string): RegionsSearchEditorState => {
        return editors[editorId] || getDefaultRegionsSearchEditorState();
    }
)((state: State, editorId: string) => editorId);
